import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/core/api.service';
import { TopupTicketStore } from './topup-ticket.store';
import { LoggingService } from '../../shared/services/core/logging.service';
import { TicketWithBalanceModel } from './models/topup-ticket.model';
import { TopUpTicketPostModel } from './models/topup-ticket-post.model';
import { ManageTicketStatusModel } from './models/topup-ticket-manage.model';

@Injectable({
  providedIn: 'root',
})
export class TopupTicketService {
  constructor(private api: ApiService, private topupTicketStore: TopupTicketStore, private logService: LoggingService) {}

  public getTicketsWithBalance(gameNumber: number): Observable<TicketWithBalanceModel[]> {
    this.logService.debug('Getting tickets with balance for game', gameNumber);
    return this.api.get<TicketWithBalanceModel>(`tickets/ticketswithbalance?gamenumber=${gameNumber}`).pipe(
      tap((tickets) => {
        this.topupTicketStore.setTickets(tickets);
      })
    );
  }

  public topUpTickets(topups: TopUpTicketPostModel[]): Observable<TopUpTicketPostModel[]> {
    this.logService.debug('Topping up tickets', topups);
    // Amount needs to be in pence / cents
    topups.map((topup) => (topup.amount *= 100));
    return this.api.postWithArray<TopUpTicketPostModel>('tickets/topuptickets', topups);
  }

  public manageTicketStatus(manageTicket: ManageTicketStatusModel): Observable<number> {
    this.logService.debug('Managing ticket status', manageTicket);
    return this.api.post<ManageTicketStatusModel>('tickets/manageticketstatus', manageTicket);
  }
}
